import { orderBy, find, flatten, uniqBy, uniq, cloneDeep, map, some, filter, findIndex, unionBy, sortBy, isEqual } from 'lodash';

import { utrTypeIds, acceptanceRankingValues, drawCategoryTypeIds, eventFormatTypeIds, acceptanceBucketTypes, sportTypeIds, allPositionsForDisplay, divisionRegistrationTypeIds, paymentStatusTypeIds, divisionFormatTypeIds, acceptanceBucketTypeSortKey } from '../utils/eventConstants';
import { getRatingDetails, newGuid, setRatingChoice, updateOrderOfPlayMatches, updateDrawRoundMatches, updateLiveBanner } from '../utils';
import { mergeArraysOfObjectsById } from '../utils/misc';
import { readMatchSlice } from '../utils/postScoreCascade';

import {
    EVENT_PROFILE_REINIT,
    EVENT_PROFILE_GET_EVENT,
    EVENT_PROFILE_GET_EVENT_SUCCESS,
    EVENT_PROFILE_GET_EVENT_FAILURE,
    EVENT_PROFILE_REFRESH_EVENT_SUCCESS,
    EVENT_PROFILE_GET_DRAWS,
    EVENT_PROFILE_GET_DRAWS_SUCCESS,
    EVENT_PROFILE_GET_DRAWS_FAILURE,
    EVENT_PROFILE_GET_PLAYERS,
    EVENT_PROFILE_GET_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_PLAYERS_FAILURE,
    EVENT_PROFILE_ADD_ELIGIBLE_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_ELIGIBLE_PLAYERS,
    EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_FAILURE,
    EVENT_PROFILE_DELETE_ELIGIBLE_PLAYER_SUCCESS,
    EVENT_PROFILE_DELETE_PRE_REGISTRATION_INVITE_SUCCESS,
    EVENT_PROFILE_GET_PRE_REG_FILTERS,
    EVENT_PROFILE_GET_PRE_REG_FILTERS_SUCCESS,
    EVENT_PROFILE_GET_PRE_REG_FILTERS_FAILURE,
    EVENT_PROFILE_GET_WITHDRAWN_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_TEAMS,
    EVENT_PROFILE_GET_TEAMS_SUCCESS,
    EVENT_PROFILE_GET_TEAMS_FAILURE,
    EVENT_PROFILE_GET_DRAW,
    EVENT_PROFILE_GET_DRAW_SUCCESS,
    EVENT_PROFILE_GET_DRAW_FAILURE,
    EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_SUCCESS,
    EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_FAILURE,
    EVENT_PROFILE_OOP_MATCH_REFRESH_SUCCESS,
    EVENT_PROFILE_LIVE_SCORE_UPDATE,
    EVENT_PROFILE_EVENT_TEAM_STANDINGS_SUCCESS,
    EVENT_PROFILE_GET_LOCATIONS,
    EVENT_PROFILE_GET_LOCATIONS_SUCCESS,
    EVENT_PROFILE_GET_LOCATIONS_FAILURE,
    EVENT_PROFILE_FETCH_MATCH_SHEET,
    EVENT_PROFILE_FETCH_MATCH_SHEET_SUCCESS,
    EVENT_PROFILE_FETCH_MATCH_SHEET_FAILURE,
    EVENT_PROFILE_GET_MATCH_SHEET_MATCHES_SUCCESS,
    EVENT_PROFILE_GET_OFFICIALS,
    EVENT_PROFILE_GET_OFFICIALS_SUCCESS,
    EVENT_PROFILE_GET_OFFICIALS_FAILURE,
    EVENT_PROFILE_ORDER_PLAYERS,
    EVENT_PROFILE_GET_DRAW_OFFICIALS_SUCCESS,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST_SUCCESS,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST_FAILURE,
    EVENT_PROFILE_SHOW_ADMIN_SPLASH,
    EVENT_PROFILE_HIDE_ADMIN_SPLASH,
    EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG,
    EVENT_PROFILE_SET_OVERVIEW_TAB_STATE,
    EVENT_PROFILE_SET_DRAWS_TAB_STATE,
    EVENT_PROFILE_SET_PLAYERS_TAB_STATE,
    EVENT_PROFILE_GET_ATTACHMENTS,
    EVENT_PROFILE_GET_ATTACHMENTS_SUCCESS,
    EVENT_PROFILE_GET_ATTACHMENTS_FAILURE,
    EVENT_PROFILE_DRAW_CONTACTS_SUCCESS,
    EVENT_PROFILE_GET_REG_PAYMENTS,
    EVENT_PROFILE_GET_REG_PAYMENTS_SUCCESS,
    EVENT_PROFILE_GET_REG_PAYMENTS_FAILURE,
    EVENT_PROFILE_GET_META_SUCCESS,
    EVENT_PROFILE_EDIT_TEAM_STANDING_SUCCESS,
    EVENT_PROFILE_DELETE_TEAM_STANDING_SUCCESS,
    EVENT_PROFILE_SET_PLAYER_WILDCARD_SUCCESS,
    EVENT_PROFILE_GET_EVENT_REGIONS,
    EVENT_PROFILE_GET_EVENT_REGIONS_SUCCESS,
    EVENT_PROFILE_MOVE_PLAYER_TO_ROUND_SUCCESS,
    EVENT_PROFILE_CROP_BANNER_PHOTO_SUCCESS,
    EVENT_PROFILE_REG_ADD_TEAMMATE,
    EVENT_PROFILE_GET_MATCH_SUCCESS,
    EVENT_PROFILE_PUBLISH_SUCCESS,
    EVENT_PROFILE_UNPUBLISH_SUCCESS,
    EVENT_PROFILE_DELETE_FAILURE,
    EVENT_PROFILE_HIDE_DELETE_FAILED_POPUP,
    EVENT_PROFILE_REMOVE_BANNER_PHOTO_SUCCESS,
    EVENT_PROFILE_GET_DRAW_STATS,
    EVENT_PROFILE_GET_DRAW_STATS_FAILURE,
    EVENT_PROFILE_GET_DRAW_STATS_SUCCESS,
    EVENT_PROFILE_SET_REG_CONFIRMATION,
    EVENT_PROFILE_GET_INVITES_SUCCESS,
    EVENT_PROFILE_REG_CLEAR_TEAMMATES,
    EVENT_PROFILE_SET_REG_DIVISION_ID,
    EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS_SUCCESS,
    EVENT_PROFILE_SET_DIVISIONS_BASED_DATE,
    EVENT_PROFILE_RESET_DIVISIONS_BASED_DATE,
    EVENT_PROFILE_GET_REGISTRATIONS,
    EVENT_PROFILE_GET_REGISTRATIONS_SUCCESS,
    EVENT_PROFILE_GET_REGISTRATIONS_FAILURE,
    EVENT_PROFILE_GET_FACILITIES,
    EVENT_PROFILE_GET_FACILITIES_SUCCESS,
    EVENT_PROFILE_GET_FACILITIES_FAILURE,
    EVENT_PROFILE_CREATE_PRINT_CONFIG,
    EVENT_PROFILE_CREATE_PRINT_CONFIG_SUCCESS,
    EVENT_PROFILE_CREATE_PRINT_CONFIG_FAILURE,
    EVENT_PROFILE_PRINT_TEST_PAGE,
    EVENT_PROFILE_PRINT_TEST_PAGE_SUCCESS,
    EVENT_PROFILE_PRINT_TEST_PAGE_FAILURE,
    EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES,
    EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_SUCCESS,
    EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_FAILURE,
    EVENT_PROFILE_SET_DECLINE_INVITATION_DATA,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_SUCCESS,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_FAILURE,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_SUCCESS,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_FAILURE,
    EVENT_PROFILE_GET_MATCHSHEET_DATA,
    EVENT_PROFILE_GET_MATCHSHEET_DATA_SUCCESS,
    EVENT_PROFILE_GET_MATCHSHEET_DATA_FAILURE,
    EVENT_PROFILE_GET_DRAW_ALL_STATS,
    EVENT_PROFILE_GET_DRAW_ALL_STATS_SUCCESS,
    EVENT_PROFILE_GET_DRAW_ALL_STATS_FAILURE,
    EVENT_PROFILE_GET_MEDALPRINT_DATA,
    EVENT_PROFILE_GET_MEDALPRINT_DATA_SUCCESS,
    EVENT_PROFILE_GET_MEDALPRINT_DATA_FAILURE,
    EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS,
    EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_FAILURE,
    EVENT_PROFILE_SEND_EVENT_INVITE,
    EVENT_PROFILE_SEND_EVENT_INVITE_SUCCESS,
    EVENT_PROFILE_SEND_EVENT_INVITE_FAILURE,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_RESET,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_FAILURE,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_SUCCESS,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS,
    EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS,
    EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_SUCCESS,
    EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_FAILURE,
    EVENT_PROFILE_ADD_CHANGE_PARTNER_UPDATE,
    EVENT_PROFILE_RESET_REGISTERED_DOUBLES_DIVISIONS,
    EVENT_PROFILE_GET_PRE_REG_STATS,
    EVENT_PROFILE_GET_PRE_REG_STATS_SUCCESS,
    EVENT_PROFILE_GET_PRE_REG_STATS_FAILURE,
    EVENT_PROFILE_REG_CLEAR_PRE_REG_INVITE,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST_DATA_CLEAR,
    EVENT_PROFILE_SORT_ATTACHMENTS,
    EVENT_PROFILE_SORT_ATTACHMENTS_FAILURE,
    EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS,
    EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_SUCCESS,
    EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_FAILURE,
    EVENT_PROFILE_FETCH_MATCH_SHEET_V2,
    EVENT_PROFILE_FETCH_MATCH_SHEET_V2_SUCCESS,
    EVENT_PROFILE_FETCH_MATCH_SHEET_V2_FAILURE,
    EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION,
    EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_SUCCESS,
    EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_FAILURE,
    EVENT_PROFILE_GET_DIVISION_COUNTS,
    EVENT_PROFILE_GET_DIVISION_COUNTS_SUCCESS,
    EVENT_PROFILE_GET_DIVISION_COUNTS_FAILURE,
} from '../actions/actionTypes/event-profile-action-types';
import { SAVED_LISTS_PLAYER_MARKED_SAVED, SAVED_LISTS_PLAYER_MARKED_UNSAVED } from '../actions/actionTypes/saved-lists-action-types';

import { getDefaultSortOrderForDivision, getDefaultSortParamForDivision, getDefaultSortParamForPickleballDivision, getOrganizerRating, getUserAge } from '../utils/events';
import { comparator } from '../utils/comparator';
import { getComparatorArguments } from '../utils/sorting';

const MERGE_FIELDS_FROM_GET_MATCH = [
    'result',
    'resultId',
    'position1',
    'position2',
    'participatingMembers',
    'completed',
    'outcome',
    'winnerOutputMatchId',
    'loserOutputMatchId',
];

const mergeMatchFields = (target, payload) => {
    const next = { ...target };
    MERGE_FIELDS_FROM_GET_MATCH.forEach(f => {
        if (f in payload) {
            next[f] = payload[f];
        }
    });
    return next;
};

const patchSliceMatch = (entry, payload) => {
    const core = readMatchSlice(entry);
    if (!core) {
        return entry;
    }
    const merged = mergeMatchFields(core.target, payload);
    return core.nested ? { ...entry, matchDetails: merged } : merged;
};

const _ = { orderBy, find, flatten, uniqBy, uniq, cloneDeep, map, some, filter, findIndex, unionBy };

const initialState = {
    event: {
        loading: false,
        error: null,
        data: null,
    },
    players: {
        loading: false,
        error: null,
        data: null,
        playersDict: {},
        playersDictByMemberId: {},
        membersInDraw: {},
        membersInWaitlist: {},
        withdrawn: null,
    },
    teams: {
        loading: true,
        error: null,
        data: null,
        teamsDict: {},
        teamsInDraw: {},
        membersInDraw: {},
    },
    draws: {
        loading: false,
        error: null,
        data: null,
        drawsDict: {},
    },
    registrations: {
        loading: false,
        error: null,
        data: null,
    },
    facilities: {
        loading: false,
        error: null,
        printConfigError: null,
        printConfigLoading: false,
        printTestLoading: false,
        printTestError: null,
        printTestSuccess: false,
        data: null,
    },
    parentDraw: {
        loading: false,
        error: null,
        data: null,
    },
    currentDraw: {
        loading: false,
        error: null,
        data: null,
        unsavedChanges: false,
    },
    locations: {
        loading: false,
        error: null,
        data: null,
    },
    officials: {
        loading: false,
        error: null,
        data: null,
    },
    drawOfficials: {
        loading: false,
        error: null,
        data: null,
    },
    matchSheet: {
        loading: false,
        error: null,
        data: null,
        matches: [],
    },
    currentMemberRegistration: {
        loading: false,
        error: null,
        data: null,
    },
    matchSheetData: {
        loading: false,
        error: null,
        data: null,
    },
    drawAllStats: {
        loading: false,
        error: null,
        data: null,
    },
    orderOfPlay: {
        loading: false,
        error: null,
        data: null,
    },
    orderOfPlaySchedule: {
        loading: false,
        error: null,
        data: null,
    },
    nextAvailableSchedule: {
        loading: false,
        error: null,
        schedule: null,
        eventId: null,
    },
    liveMatches: {
        loading: false,
        loadedAtLeastOnce: false,
        showLoader: false,
        matches: [],
        facilitiesAvailable: [],
    },
    liveMatchIdsInProgress: [],
    stats: {
        loading: false,
        error: null,
        data: null,
    },
    overviewTabState: {
        divisionsExpanded: false,
        descriptionExpanded: false,
    },
    drawsTabState: {
        activeRound: 0,
    },
    playersTabState: {
        filter: null,
    },
    regPaymentRefund: {
        loading: true,
        loaded: false,
        error: null,
    },
    regions: {
        data: [],
        error: null,
        loading: false,
        loaded: false,
    },
    medalPrintData: {
        loading: false,
        error: null,
        data: null,
    },
    needsPartnerPlayers: {
        loading: false,
        error: null,
        data: null,
    },
    invites: [],
    weatherNotifications: [],
    metaData: {},
    acceptance: {},
    adminSplash: null,
    justPublished: false,
    redirectUrl: null,
    contacts: null,
    teamStandings: null,
    regConfirmation: null,
    declineInvitationData: null,
    eventInviteEmail: {
        loading: false,
        error: null,
        success: null,
    },
    playerMessageEmail: {
        loading: false,
        error: null,
        errorMessage: null,
        success: null,
    },
    registeredDoublesDivisions: {
        loading: false,
        error: null,
        data: null,
    },
    changePartnerUpdates: {},
    preRegFilterOptions: {
        data: null,
        loading: false,
        error: null,
    },
    preRegStats: {
        data: null,
        loading: false,
        error: null,
    },
    eligiblePlayers: {
        loading: false,
        error: null,
        data: null,
    },
    upcomingRecurringEvents: {
        loading: false,
        error: null,
        data: null,
    },
    divisionCounts: {
        loading: false,
        error: null,
        data: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case EVENT_PROFILE_REINIT: {
            return {
                ...initialState,
                justPublished: state.justPublished,
            };
        }
        case EVENT_PROFILE_GET_EVENT: {
            return {
                ...state,
                event: {
                    loading: true,
                    error: null,
                    data: null,
                },
                redirectUrl: null,
            };
        }
        case EVENT_PROFILE_GET_EVENT_SUCCESS: {
            const event = action.payload;

            const { sportTypeId } = event;
            const filteredEventDivision = event.eventDivisions?.length ? event.eventDivisions.filter(div => !div.isEventEntryFeeDivision) : [];
            const currentPlayersTabState = state.playersTabState?.filter === null ? null : state.playersTabState;
            const currentDivisionIndex = filteredEventDivision.findIndex(d => d.id === currentPlayersTabState?.divisionId);
            const divisionIndex = currentDivisionIndex !== -1 ? currentDivisionIndex : 0;

            const playersTabState = filteredEventDivision?.length ? {
                divisionId: filteredEventDivision[divisionIndex].id,
                divisionName: filteredEventDivision[divisionIndex].name,
                divisionFormatTypeId: filteredEventDivision[divisionIndex].divisionFormatTypeId,
                teamPaymentTypeId: filteredEventDivision[divisionIndex].teamPaymentTypeId,
                registeredCount: filteredEventDivision[divisionIndex].registeredCount,
                selectedStatus: {
                    value: 'registered',
                    label: 'Registered',
                },
                selectedPosition: {
                    value: '',
                    label: allPositionsForDisplay,
                },
                specificDivisionDateEnabled: filteredEventDivision[divisionIndex].specificDivisionDateEnabled,
                specificDivisionDateUtc: filteredEventDivision[divisionIndex].specificDivisionDateUtc,
                sortParam: sportTypeId === sportTypeIds.PICKLEBALL ? getDefaultSortParamForPickleballDivision(filteredEventDivision[divisionIndex]) : getDefaultSortParamForDivision(filteredEventDivision[divisionIndex]),
                sortType: getDefaultSortOrderForDivision(filteredEventDivision[divisionIndex]),
            } : null;

            const adminAddedPaymentRequiredDivisionIds = [...new Set(event?.currentMember?.registeredDivisions?.filter(division => division.divisionRegistrationTypeId === divisionRegistrationTypeIds.ADMIN_ADD_PAYMENT_REQUIRED && division.paymentStatusTypeId !== paymentStatusTypeIds.PAID).map(division => division.id))];

            const registeredDivisionIds = [];
            const registeredDivisionDict = {};
            const eventDivisionDict = {};
            if (event.currentMember?.registeredDivisions?.length) {
                // default to Need Partner when admin added players to doubles divisions without a partner
                event.eventDivisions.forEach(div => {
                    if (adminAddedPaymentRequiredDivisionIds.includes(div.id) && div.divisionFormatTypeId !== divisionFormatTypeIds.SINGLES && !div.player2) {
                        div.player2 = {
                            firstName: 'Need',
                            lastName: 'Partner',
                            name: 'Need Partner',
                            needsPartner: true,
                        };
                    }
                    eventDivisionDict[div.id] = div;
                });
                event.currentMember.registeredDivisions.forEach(div => {
                    div.selfWithdrawAllowed = eventDivisionDict[div.id]?.selfWithdrawAllowed;
                    registeredDivisionIds.push(div.id);
                    registeredDivisionDict[div.id] = div;
                });
            }

            return {
                ...state,
                event: {
                    loading: false,
                    error: null,
                    data: {
                        ...event,
                        currentMember: {
                            ...event.currentMember,
                            registeredDivisionIds,
                            registeredDivisionDict,
                        },
                    },
                },
                redirectUrl: null,
                liveMatchIdsInProgress: event.liveMatchIds ?? [],
                playersTabState,
                drawsTabState: {
                    activeRound: 0,
                },
                overviewTabState: {
                    divisionsExpanded: false,
                    descriptionExpanded: false,
                },
            };
        }
        case EVENT_PROFILE_GET_EVENT_FAILURE: {
            return {
                ...state,
                event: {
                    loading: false,
                    error: action.payload || true,
                    data: null,
                },
                redirectUrl: action.payload?.redirectUrl,
            };
        }
        case EVENT_PROFILE_REFRESH_EVENT_SUCCESS: {
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        ...action.payload,
                    },
                },
            };
        }
        case EVENT_PROFILE_GET_DRAWS: {
            return {
                ...state,
                draws: {
                    loading: true,
                    error: null,
                    data: null,
                    drawsDict: {},
                },
            };
        }
        case EVENT_PROFILE_GET_DRAWS_SUCCESS: {
            const { draws } = action.payload;
            const drawsDict = {};
            draws.forEach(draw => {
                let hasPlayoff = false;
                const isGroupedDraw = draw.categoryTypeId === drawCategoryTypeIds.GROUPED;
                draw.isGroupedDraw = isGroupedDraw;
                draw.childDraws.forEach(cd => {
                    cd.isChildDraw = true;
                    cd.parentDrawId = draw.id;
                    cd.parentDrawName = draw.name;
                    cd.isGroupedChildDraw = isGroupedDraw;
                    drawsDict[cd.id] = {
                        ...cd,
                        isChildDraw: true,
                        parentDrawId: draw.id,
                        parentDrawName: draw.name,
                        isGroupedChildDraw: isGroupedDraw,
                    };
                    if (cd.categoryTypeId === drawCategoryTypeIds.AUTO_PLAYOFF ||
                        cd.categoryTypeId === drawCategoryTypeIds.FIVESIXPLAYOFF ||
                        cd.categoryTypeId === drawCategoryTypeIds.THREEFOURPLAYOFF) {
                        hasPlayoff = true;
                    }
                });
                drawsDict[draw.id] = {
                    ...draw,
                    hasPlayoff,
                };
                draw.hasPlayoff = hasPlayoff;
            });
            return {
                ...state,
                draws: {
                    loading: false,
                    error: null,
                    data: sortBy(draws, 'name'),
                    drawsDict,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAWS_FAILURE: {
            return {
                ...state,
                draws: {
                    loading: false,
                    error: true,
                    data: null,
                    drawsDict: {},
                },
            };
        }
        case EVENT_PROFILE_CREATE_PRINT_CONFIG: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    printConfigError: null,
                    printConfigLoading: true,
                },
            };
        }
        case EVENT_PROFILE_CREATE_PRINT_CONFIG_SUCCESS: {
            const facilityIndex = state.facilities.data.findIndex(facility => facility?.clubLocationFacilityId === action?.payload?.clubLocationFacilityId);
            const foundItem = state?.facilities?.data[facilityIndex] || {};

            if (!state?.facilities?.data[facilityIndex]) {
                return {
                    ...state,
                };
            }

            const newItemState = {
                ...foundItem,
                operationQueueId: action?.payload?.operationQueueId,
            };

            const cloneData = state?.facilities?.data ? [
                ...state.facilities.data,
            ] : [];

            cloneData[facilityIndex] = newItemState;

            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    printConfigError: null,
                    printConfigLoading: false,
                    data: cloneData,
                },
            };
        }
        case EVENT_PROFILE_CREATE_PRINT_CONFIG_FAILURE: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    printConfigError: true,
                    printConfigLoading: false,
                },
            };
        }
        case EVENT_PROFILE_PRINT_TEST_PAGE: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    printTestLoading: true,
                    printTestError: null,
                    printTestSuccess: false,
                },
            };
        }
        case EVENT_PROFILE_PRINT_TEST_PAGE_SUCCESS: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    printTestLoading: false,
                    printTestError: null,
                    printTestSuccess: true,
                },
            };
        }
        case EVENT_PROFILE_PRINT_TEST_PAGE_FAILURE: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    printTestLoading: false,
                    printTestError: true,
                    printTestSuccess: false,
                },
            };
        }

        case EVENT_PROFILE_GET_FACILITIES: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_FACILITIES_SUCCESS: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_FACILITIES_FAILURE: {
            return {
                ...state,
                facilities: {
                    ...state.facilities,
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_REGISTRATIONS: {
            return {
                ...state,
                registrations: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_REGISTRATIONS_SUCCESS: {
            return {
                ...state,
                registrations: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_REGISTRATIONS_FAILURE: {
            return {
                ...state,
                registrations: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_MATCHSHEET_DATA: {
            return {
                ...state,
                matchSheetData: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_MATCHSHEET_DATA_SUCCESS: {
            return {
                ...state,
                matchSheetData: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_MATCHSHEET_DATA_FAILURE: {
            return {
                ...state,
                matchSheetData: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_ALL_STATS: {
            return {
                ...state,
                drawAllStats: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_ALL_STATS_SUCCESS: {
            return {
                ...state,
                drawAllStats: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_ALL_STATS_FAILURE: {
            return {
                ...state,
                drawAllStats: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_PLAYERS: {
            return {
                ...state,
                players: {
                    ...state.players,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_PLAYERS_SUCCESS: {
            let { players } = action.payload;
            const { utrTypeId, eventDivisions, eventSchedule } = state.event.data || {};

            const playersDict = {
                ...state.players.playersDict,
            }; // player dictionary by playerId
            const playersDictByMemberId = {
                ...state.players.playersDictByMemberId,
            }; // player dictionary by memberId

            const divisionsDict = {};
            // eslint-disable-next-line no-unused-expressions
            eventDivisions?.forEach(div => {
                divisionsDict[div.id] = div;
            });

            const ageRestrictedDivision = eventDivisions?.find(div => div.restrictAge);
            players = players.map(player => {
                let playerDrawNames = '';
                (player.draws || []).forEach(draw => {
                    if (state.draws.drawsDict?.[draw.id]?.name) {
                        playerDrawNames = playerDrawNames.length ? `${playerDrawNames}, ${state.draws.drawsDict[draw.id].name}` : state.draws.drawsDict[draw.id].name;
                    }
                });
                (player.divisions || []).forEach(div => {
                    if (divisionsDict[div.id]?.name) {
                        div.name = divisionsDict[div.id]?.name;
                    }
                });
                const utrRangeDisplay = player.utrRange?.minUtrDisplay && player.utrRange?.maxUtrDisplay ? `${player.utrRange.minUtrDisplay}-${player.utrRange.maxUtrDisplay}` : null;
                player.age = getUserAge(player.birthDate, ageRestrictedDivision?.restrictAgeByDateType, eventSchedule?.eventStartUtc);
                return {
                    ...player,
                    utrRangeDisplay,
                    playerDrawNames,
                };
            });

            if (players?.length) {
                players.forEach(player => {
                    // merge divisions with players from withdrawn call
                    if (playersDict[player.playerId]) {
                        playersDict[player.playerId].divisions = mergeArraysOfObjectsById(
                            playersDict[player.playerId].divisions,
                            player.divisions,
                        );
                    } else {
                        playersDict[player.playerId] = player;
                    }
                    // merge divisions with players from withdrawn call
                    if (playersDictByMemberId[player.memberId]) {
                        playersDictByMemberId[player.memberId].divisions = mergeArraysOfObjectsById(
                            playersDictByMemberId[player.memberId].divisions,
                            player.divisions,
                        );
                    } else {
                        playersDictByMemberId[player.memberId] = player;
                    }
                });
                _.orderBy(players, utrTypeId === utrTypeIds.SANCTIONED ? ['ratingStatusSinglesVal', 'utrSingles'] : ['myUtrSingles', 'utrRangeDisplay'], ['desc', 'desc']);
            }

            return {
                ...state,
                players: {
                    ...state.players,
                    loading: false,
                    error: null,
                    data: players,
                    playersDict,
                    playersDictByMemberId,
                },
            };
        }
        case EVENT_PROFILE_GET_PLAYERS_FAILURE: {
            return {
                ...state,
                players: {
                    ...state.players,
                    loading: false,
                    error: true,
                },
            };
        }
        case SAVED_LISTS_PLAYER_MARKED_SAVED: {
            // Keep an already-loaded event player's bookmark filled after it's saved from a card,
            // without re-fetching the (large) all-players endpoint. The save modal is shared across
            // surfaces, so this action can fire for a player not in this event — leave state
            // untouched then to avoid a needless re-render of the list.
            const { playerId } = action;
            const isInList = (list) => Array.isArray(list) && list.some(player => player.playerId === playerId);
            if (!isInList(state.players.data) && !isInList(state.players.withdrawn) && !state.players.playersDict?.[playerId]) {
                return state;
            }
            const markSaved = (list) => (Array.isArray(list)
                ? list.map(player => (player.playerId === playerId ? { ...player, isSaved: true } : player))
                : list);
            const playersDict = state.players.playersDict?.[playerId]
                ? { ...state.players.playersDict, [playerId]: { ...state.players.playersDict[playerId], isSaved: true } }
                : state.players.playersDict;
            return {
                ...state,
                players: {
                    ...state.players,
                    data: markSaved(state.players.data),
                    withdrawn: markSaved(state.players.withdrawn),
                    playersDict,
                },
            };
        }
        case SAVED_LISTS_PLAYER_MARKED_UNSAVED: {
            // Mirror of SAVED_LISTS_PLAYER_MARKED_SAVED: after a remove-from-all-lists, flip an
            // already-loaded event player's bookmark back to outline without re-fetching the (large)
            // all-players endpoint. The remove modal is shared across surfaces, so this can fire for
            // a player not in this event — leave state untouched then to avoid a needless re-render.
            const { playerId } = action;
            const isInList = (list) => Array.isArray(list) && list.some(player => player.playerId === playerId);
            if (!isInList(state.players.data) && !isInList(state.players.withdrawn) && !state.players.playersDict?.[playerId]) {
                return state;
            }
            const markUnsaved = (list) => (Array.isArray(list)
                ? list.map(player => (player.playerId === playerId ? { ...player, isSaved: false } : player))
                : list);
            const playersDict = state.players.playersDict?.[playerId]
                ? { ...state.players.playersDict, [playerId]: { ...state.players.playersDict[playerId], isSaved: false } }
                : state.players.playersDict;
            return {
                ...state,
                players: {
                    ...state.players,
                    data: markUnsaved(state.players.data),
                    withdrawn: markUnsaved(state.players.withdrawn),
                    playersDict,
                },
            };
        }
        case EVENT_PROFILE_ADD_ELIGIBLE_PLAYERS_SUCCESS: {
            const addedPlayers = action.payload;
            return {
                ...state,
                eligiblePlayers: {
                    ...state.eligiblePlayers,
                    loading: false,
                    error: null,
                    data: addedPlayers,
                },
            };
        }
        case EVENT_PROFILE_GET_ELIGIBLE_PLAYERS: {
            return {
                ...state,
                eligiblePlayers: {
                    ...state.eligiblePlayers,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_SUCCESS: {
            const { eligiblePlayers, total } = action.payload;
            return {
                ...state,
                eligiblePlayers: {
                    ...state.eligiblePlayers,
                    loading: false,
                    error: null,
                    data: { players: eligiblePlayers, total },
                },
            };
        }
        case EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_FAILURE: {
            return {
                ...state,
                eligiblePlayers: {
                    ...state.eligiblePlayers,
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES: {
            return {
                ...state,
                preRegInvites: {
                    ...state.preRegInvites,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_SUCCESS: {
            const { preRegistrationInviteMemberDetails, total } = action.payload;
            return {
                ...state,
                preRegInvites: {
                    ...state.preRegInvites,
                    loading: false,
                    error: null,
                    data: { players: preRegistrationInviteMemberDetails, total },
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_FAILURE: {
            return {
                ...state,
                preRegInvites: {
                    ...state.preRegInvites,
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_DELETE_ELIGIBLE_PLAYER_SUCCESS: {
            return {
                ...state,
                eligiblePlayers: {
                    loading: false,
                    error: null,
                    data: { players: state.eligiblePlayers.data.players.filter((player) => player.playerId !== action.payload), total: state.eligiblePlayers.data.total - 1 },
                },
            };
        }
        case EVENT_PROFILE_DELETE_PRE_REGISTRATION_INVITE_SUCCESS: {
            return {
                ...state,
                preRegInvites: {
                    ...state.preRegInvites,
                    loading: false,
                    error: null,
                    data: { players: state.preRegInvites.data.players.filter((player) => player.preRegistrationInviteId !== action.payload), total: state.preRegInvites.data.total - 1 },
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REG_FILTERS: {
            return {
                ...state,
                preRegFilterOptions: {
                    ...state.preRegFilterOptions,
                    data: {},
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REG_FILTERS_SUCCESS: {
            const {
                divisionCategories,
                medalTiers,
                statuses,
                sentDates,
                expirationDates,
            } = action.payload;
            return {
                ...state,
                preRegFilterOptions: {
                    ...state.preRegFilterOptions,
                    data: {
                        divisionCategories,
                        medalTiers,
                        statuses,
                        sentDates,
                        expirationDates,
                    },
                    loading: false,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REG_FILTERS_FAILURE: {
            return {
                ...state,
                preRegFilterOptions: {
                    ...state.preRegFilterOptions,
                    data: {},
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REG_STATS: {
            return {
                ...state,
                preRegStats: {
                    ...state.preRegStats,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REG_STATS_SUCCESS: {
            const { preRegistrationDivisionCategoryInviteStats } = action.payload;
            return {
                ...state,
                preRegStats: {
                    ...state.preRegStats,
                    loading: false,
                    error: null,
                    data: preRegistrationDivisionCategoryInviteStats,
                },
            };
        }
        case EVENT_PROFILE_GET_PRE_REG_STATS_FAILURE: {
            return {
                ...state,
                preRegStats: {
                    ...state.preRegStats,
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_GET_WITHDRAWN_PLAYERS_SUCCESS: {
            let { players } = action.payload;
            const { eventDivisions, eventSchedule } = state.event.data || {};

            const playersDict = {
                ...state.players.playersDict,
            };
            const playersDictByMemberId = {
                ...state.players.playersDictByMemberId,
            };
            if (players?.length) {
                players.forEach(player => {
                    // merge divisions with players from all-players call
                    if (playersDict[player.playerId]) {
                        playersDict[player.playerId].divisions = mergeArraysOfObjectsById(
                            playersDict[player.playerId].divisions,
                            player.divisions,
                        );
                    } else {
                        playersDict[player.playerId] = player;
                    }
                    // merge divisions with players from all-players call
                    if (playersDictByMemberId[player.memberId]) {
                        playersDictByMemberId[player.memberId].divisions = mergeArraysOfObjectsById(
                            playersDictByMemberId[player.memberId].divisions,
                            player.divisions,
                        );
                    } else {
                        playersDictByMemberId[player.memberId] = player;
                    }
                });
            }
            const ageRestrictedDivision = eventDivisions?.find(div => div.restrictAge);
            players = players.map(player => {
                const utrRangeDisplay = player.utrRange?.minUtrDisplay && player.utrRange?.maxUtrDisplay ? `${player.utrRange.minUtrDisplay}-${player.utrRange.maxUtrDisplay}` : null;
                player.age = getUserAge(player.birthDate, ageRestrictedDivision?.restrictAgeByDateType, eventSchedule?.eventStartUtc);
                return {
                    ...player,
                    utrRangeDisplay,
                };
            });
            return {
                ...state,
                players: {
                    ...state.players,
                    withdrawn: players,
                    playersDict,
                    playersDictByMemberId,
                },
            };
        }
        case EVENT_PROFILE_GET_TEAMS: {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_TEAMS_SUCCESS: {
            let { teams } = action.payload;
            const utrTypeId = state.event.data?.utrTypeId;
            const { data: players, playersDictByMemberId } = state.players;

            const teamsDict = {};

            teams = teams.map(team => {
                let teamDrawNames = '';
                (team.draws || []).forEach(drawId => {
                    if (state.draws.drawsDict?.[drawId]?.name) {
                        teamDrawNames = teamDrawNames.length ? `${teamDrawNames}, ${state.draws.drawsDict[drawId].name}` : state.draws.drawsDict[drawId].name;
                    }
                });
                if (team.members) {
                    if (playersDictByMemberId[team.members[0]] && playersDictByMemberId[team.members[1]]) {
                        team.displayName = `${playersDictByMemberId[team.members[0]]?.firstName[0]}. ${playersDictByMemberId[team.members[0]]?.lastName} / ${playersDictByMemberId[team.members[1]]?.firstName[0]}. ${playersDictByMemberId[team.members[1]]?.lastName}`;
                    }
                }
                return {
                    ...team,
                    teamDrawNames,
                };
            });

            // doubles division registration teams are currently not stored by the api, only the memberId of the partner
            // so we have to create these teams in the client to display them in the draw teams lists

            players.forEach(p => {
                const memberId1 = p.memberId;
                // find their partner's ids in different divisions
                p.divisions.forEach(playerDivisionObj => {
                    const memberId2 = playerDivisionObj?.partners[0];
                    if (memberId2) {
                        const memberIds = [memberId1, memberId2];
                        let existingTeam;
                        teams.forEach(team => {
                            const sortedTeamMembers = [...team.members].sort((a, b) => a - b);
                            const sortedMemberIds = [...memberIds].sort((a, b) => a - b);
                            if (isEqual(sortedTeamMembers, sortedMemberIds)) {
                                existingTeam = true;
                            }
                        });
                        if (!existingTeam) {
                            let displayName;
                            if (playersDictByMemberId[memberId1] && playersDictByMemberId[memberId2]) {
                                displayName = `${playersDictByMemberId[memberId1]?.firstName[0]}. ${playersDictByMemberId[memberId1]?.lastName} / ${playersDictByMemberId[memberId2]?.firstName[0]}. ${playersDictByMemberId[memberId2]?.lastName}`;
                            }
                            const divisionRegTeam = {
                                id: newGuid(),
                                members: memberIds,
                                draws: [],
                                unsaved: true,
                                displayName,
                            };
                            teams.push(divisionRegTeam);
                        }
                    }
                });
            });

            if (teams?.length) {
                teams.forEach(team => {
                    teamsDict[team.id] = team;
                });
                _.orderBy(teams, utrTypeId === utrTypeIds.SANCTIONED ? 'averageDoublesUtr' : 'averageDoublesMyUtr', 'desc');
            }

            return {
                ...state,
                teams: {
                    data: teams,
                    teamsDict,
                    loading: false,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_TEAMS_FAILURE: {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_GET_ACCEPTANCE_LIST: {
            return {
                ...state,
                acceptance: {
                    ...(state.acceptance || {}),
                    [action.divisionId]: {
                        loading: true,
                        loaded: false,
                        error: null,
                    },
                },
            };
        }
        case EVENT_PROFILE_GET_ACCEPTANCE_LIST_FAILURE: {
            return {
                ...state,
                acceptance: {
                    ...(state.acceptance || {}),
                    [action.divisionId]: {
                        loading: false,
                        loaded: false,
                        error: 'Failed to load acceptance list',
                    },
                },
            };
        }
        case EVENT_PROFILE_GET_ACCEPTANCE_LIST_SUCCESS: {
            return {
                ...state,
                acceptance: {
                    ...(state.acceptance || {}),
                    [action.divisionId]: {
                        ...action.data,
                        loading: false,
                        loaded: true,
                        error: null,
                    },
                },
            };
        }
        case EVENT_PROFILE_GET_ACCEPTANCE_LIST_DATA_CLEAR: {
            return {
                ...state,
                acceptance: {},
            };
        }
        case EVENT_PROFILE_GET_DRAW: {
            const { isChildDraw, drawId } = action.payload;
            if (isChildDraw) {
                return {
                    ...state,
                    currentDraw: {
                        ...state.currentDraw,
                        loading: true,
                        error: false,
                        isChildDraw,
                        pendingId: drawId,
                    },
                };
            }
            return {
                ...state,
                parentDraw: {
                    ...state.parentDraw,
                    loading: true,
                    error: false,
                    pendingId: drawId,
                },
                currentDraw: {
                    ...state.currentDraw,
                    loading: true,
                    error: false,
                    pendingId: drawId,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_SUCCESS: {
            const { draw, isChildDraw, setAsCurrentDraw } = action.payload;

            const stateUpdate = {
                selected: [],
                selectedNotInDraw: [],
                selectedTeams: [],
                selectedTeamsNotInDraw: [],
            };
            const isGroupedDraw = draw.categoryTypeId === drawCategoryTypeIds.GROUPED;

            draw.rounds.forEach(round => {
                round.matches = sortBy(round.matches, 'matchPosition');
            });

            if (isChildDraw) {
                // load childDraw as currentDraw (keep existing parentDraw)
                stateUpdate.currentDraw = {
                    loading: false,
                    error: null,
                    data: {
                        ...draw,
                        rounds: sortBy(draw.rounds, 'number'),
                    },
                    isChildDraw,
                };
            } else {
                // load parentDraw
                stateUpdate.parentDraw = {
                    loading: false,
                    error: null,
                    data: {
                        ...draw,
                        rounds: sortBy(draw.rounds, 'number'),
                    },
                    isGroupedDraw,
                };
                if (!isGroupedDraw && setAsCurrentDraw) {
                    // if not groupedDraw, also set parentDraw as the currentDraw
                    // if grouped parentDraw, then child first child needs to be loaded automatically
                    // (handled in the action)
                    stateUpdate.currentDraw = {
                        loading: false,
                        error: null,
                        data: {
                            ...draw,
                            rounds: sortBy(draw.rounds, 'number'),
                        },
                    };
                }
            }

            return {
                ...state,
                ...stateUpdate,
            };
        }
        case EVENT_PROFILE_GET_DRAW_FAILURE: {
            const { isChildDraw } = action.payload;
            const stateUpdate = {};
            if (isChildDraw) {
                stateUpdate.currentDraw = {
                    loading: false,
                    error: true,
                    data: null,
                    isChildDraw,
                };
            } else {
                stateUpdate.parentDraw = {
                    loading: false,
                    error: true,
                    data: null,
                };
            }
            return {
                ...state,
                ...stateUpdate,
            };
        }
        case EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_SUCCESS: {
            return {
                ...state,
                orderOfPlaySchedule: {
                    ...state.orderOfPlaySchedule,
                    data: action.payload,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_FAILURE: {
            return {
                ...state,
                orderOfPlaySchedule: {
                    ...state.orderOfPlaySchedule,
                    data: null,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_OOP_MATCH_REFRESH_SUCCESS: {
            const { matchId, matchDetails } = action.payload;
            if (!state.orderOfPlaySchedule?.data?.matches?.length) {
                return state;
            }
            const updatedMatches = state.orderOfPlaySchedule.data.matches.map((item) => {
                const itemMatchId = item.matchId || item.matchDetails?.id;
                return itemMatchId === matchId ? { ...item, matchDetails } : item;
            });
            return {
                ...state,
                orderOfPlaySchedule: {
                    ...state.orderOfPlaySchedule,
                    data: { ...state.orderOfPlaySchedule.data, matches: updatedMatches },
                },
            };
        }
        case EVENT_PROFILE_EVENT_TEAM_STANDINGS_SUCCESS: {
            return {
                ...state,
                teamStandings: action.payload,
            };
        }
        case EVENT_PROFILE_EDIT_TEAM_STANDING_SUCCESS: {
            return {
                ...state,
                teamStandings: state.teamStandings.map(standing => {
                    if (standing.id === action.payload.id) {
                        return { ...action.payload };
                    }
                    return standing;
                }),
            };
        }
        case EVENT_PROFILE_DELETE_TEAM_STANDING_SUCCESS: {
            return {
                ...state,
                teamStandings: state.teamStandings.filter(({ id }) => id !== action.payload),
            };
        }
        case EVENT_PROFILE_GET_LOCATIONS: {
            return {
                ...state,
                locations: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_LOCATIONS_FAILURE: {
            return {
                ...state,
                locations: {
                    loading: false,
                    error: 'Failed to load locations',
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_LOCATIONS_SUCCESS: {
            const { locations } = action.data;
            const locationsDict = {};
            locations.forEach(loc => {
                loc.facilities.forEach(fac => {
                    fac.enabled = fac.courts.some(court => court.enabled);
                });
                loc.enabled = loc.facilities.some(fac => fac.enabled);
                locationsDict[loc.id] = loc;
            });

            return {
                ...state,
                locations: {
                    loading: false,
                    error: null,
                    data: locations,
                    locationsDict,
                },
            };
        }
        case EVENT_PROFILE_GET_OFFICIALS: {
            return {
                ...state,
                officials: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_OFFICIALS_FAILURE: {
            return {
                ...state,
                officials: {
                    loading: false,
                    error: 'Failed to load officials',
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_OFFICIALS_SUCCESS: {
            const { officials } = action.payload;
            return {
                ...state,
                officials: {
                    loading: false,
                    error: null,
                    data: officials,
                },
            };
        }

        case EVENT_PROFILE_GET_DRAW_OFFICIALS_SUCCESS: {
            return {
                ...state,
                drawOfficials: {
                    ...state.drawOfficials,
                    data: action.payload.data.matches,
                    loading: false,
                },
            };
        }
        case EVENT_PROFILE_FETCH_MATCH_SHEET: {
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_FETCH_MATCH_SHEET_SUCCESS: {
            const matchSheetDict = {};
            action.data.forEach(matchSheetObj => {
                matchSheetDict[matchSheetObj.matchId] = matchSheetObj;
            });
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    loading: false,
                    error: null,
                    data: action.data,
                    matchSheetDict,
                },
                orderOfPlay: {
                    ...state.orderOfPlay,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_FETCH_MATCH_SHEET_FAILURE: {
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_MATCH_SHEET_MATCHES_SUCCESS: {
            const { matches } = action.payload;
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    matches,
                },
            };
        }
        case EVENT_PROFILE_FETCH_MATCH_SHEET_V2: {
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_FETCH_MATCH_SHEET_V2_SUCCESS: {
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    loading: false,
                    error: null,
                    matches: action.payload.matches,
                    data: null,
                    matchSheetDict: {},
                },
            };
        }
        case EVENT_PROFILE_FETCH_MATCH_SHEET_V2_FAILURE: {
            return {
                ...state,
                matchSheet: {
                    ...state.matchSheet,
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION: {
            return {
                ...state,
                currentMemberRegistration: {
                    ...state.currentMemberRegistration,
                    loading: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_SUCCESS: {
            return {
                ...state,
                currentMemberRegistration: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_FAILURE: {
            return {
                ...state,
                currentMemberRegistration: {
                    ...state.currentMemberRegistration,
                    loading: false,
                    error: true,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_STATS: {
            return {
                ...state,
                stats: {
                    loading: true,
                    error: null,
                    data: null,
                    drawId: action.drawId,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_STATS_FAILURE: {
            return {
                ...state,
                stats: {
                    ...state.stats,
                    loading: false,
                    error: 'Failed to load draw stats...',
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_DRAW_STATS_SUCCESS: {
            return {
                ...state,
                stats: {
                    ...state.stats,
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_ORDER_PLAYERS: {
            const { organizerRatings } = state;
            const { sortParam, sortType, formatTypeId, utrTypeId } = action.payload;

            const orderedArr = formatTypeId === eventFormatTypeIds.SINGLES ? cloneDeep(state.players.data) : cloneDeep(state.teams.data);

            const getSortValue = (player) => {
                const userIsPowered = true;
                const showDecimals = true;
                switch (sortParam) {
                    case 'singlesUtr':
                    case 'regStatus': {
                        const organizerRating = getOrganizerRating(player.memberId, organizerRatings)?.singlesOrganizerRating;
                        const playerSinglesRating = getRatingDetails(setRatingChoice({ player, ratingType: 'singles', utrType: utrTypeId }), userIsPowered, showDecimals);
                        return organizerRating || playerSinglesRating.sortRating;
                    }
                    case 'doublesUtr': {
                        const organizerRating = getOrganizerRating(player.memberId, organizerRatings)?.doublesOrganizerRating;
                        const playerDoublesRating = getRatingDetails(setRatingChoice({ player, ratingType: 'doubles', utrType: utrTypeId }), userIsPowered, showDecimals);
                        return organizerRating || playerDoublesRating.sortRating;
                    }
                    default:
                        return player[sortParam];
                }
            };

            if (formatTypeId === eventFormatTypeIds.SINGLES) {
                orderedArr.forEach((player) => {
                    switch (sortParam) {
                        case 'firstName':
                            player.primarySortValue = player.firstName;
                            break;
                        case 'lastName':
                            player.primarySortValue = player.lastName;
                            break;
                        case 'singlesUtr':
                        case 'doublesUtr': {
                            player.primarySortValue = getSortValue(player);
                            break;
                        }
                        default:
                            player.primarySortValue = player.regStatusSortKey;
                            break;
                    }
                });
                orderedArr.sort(comparator(getComparatorArguments(sortParam, sortType)));
            } else {
                orderedArr.forEach((team) => {
                    const player1 = state.players.playersDictByMemberId[team.members[0]];
                    const player2 = state.players.playersDictByMemberId[team.members[1]];
                    switch (sortParam) {
                        case 'firstName':
                            team.primarySortValue = `${player1.firstName} ${player2.firstName}`;
                            break;
                        case 'singlesUtr':
                        case 'doublesUtr': {
                            const player1Rating = getSortValue(player1);
                            const player2Rating = getSortValue(player2);
                            team.primarySortValue = (parseInt(player1Rating) + parseInt(player2Rating)) / 2;
                            break;
                        }
                        default:
                            team.primarySortValue = '';
                            break;
                    }
                });
                orderedArr.sort(comparator(getComparatorArguments(sortParam, sortType)));
            }
            if (formatTypeId === eventFormatTypeIds.SINGLES) {
                return {
                    ...state,
                    players: {
                        ...state.players,
                        data: orderedArr,
                    },
                };
            }
            return {
                ...state,
                teams: {
                    ...state.teams,
                    data: orderedArr,
                },
            };
        }
        case EVENT_PROFILE_SHOW_ADMIN_SPLASH: {
            return {
                ...state,
                adminSplash: action.message,
            };
        }
        case EVENT_PROFILE_HIDE_ADMIN_SPLASH: {
            return {
                ...state,
                adminSplash: null,
            };
        }
        case EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG: {
            return {
                ...state,
                justPublished: action.payload,
            };
        }
        case EVENT_PROFILE_SET_OVERVIEW_TAB_STATE: {
            const { overviewTabState } = action.payload;
            return {
                ...state,
                overviewTabState,
            };
        }
        case EVENT_PROFILE_SET_DRAWS_TAB_STATE: {
            const { drawsTabState } = action.payload;
            return {
                ...state,
                drawsTabState,
            };
        }
        case EVENT_PROFILE_SET_PLAYERS_TAB_STATE: {
            const { playersTabState } = action.payload;
            return {
                ...state,
                playersTabState,
            };
        }
        case EVENT_PROFILE_GET_ATTACHMENTS_SUCCESS:
            return {
                ...state,
                attachments: action.data.items,
            };
        case EVENT_PROFILE_GET_ATTACHMENTS:
        case EVENT_PROFILE_GET_ATTACHMENTS_FAILURE:
            return {
                ...state,
                attachments: [],
            };
        case EVENT_PROFILE_SORT_ATTACHMENTS:
            return {
                ...state,
                attachments: action.payload,
            };
        case EVENT_PROFILE_SORT_ATTACHMENTS_FAILURE:
            return {
                ...state,
                attachments: action.previousAttachments,
            };
        case EVENT_PROFILE_DRAW_CONTACTS_SUCCESS: {
            return {
                ...state,
                contacts: action.payload,
            };
        }
        case EVENT_PROFILE_GET_REG_PAYMENTS: {
            return {
                ...state,
                regPaymentRefund: {
                    loading: true,
                    loaded: false,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_REG_PAYMENTS_FAILURE: {
            return {
                ...state,
                regPaymentRefund: {
                    loading: false,
                    loaded: true,
                    error: 'Failed to load reg payments',
                },
            };
        }
        case EVENT_PROFILE_GET_REG_PAYMENTS_SUCCESS: {
            const { divisionAmounts } = action.data;
            return {
                ...state,
                regPaymentRefund: {
                    divisionAmounts,
                    loading: false,
                    loaded: true,
                    error: null,
                },
            };
        }
        case EVENT_PROFILE_GET_META_SUCCESS: {
            return {
                ...state,
                metaData: action.data,
            };
        }
        case EVENT_PROFILE_SET_PLAYER_WILDCARD_SUCCESS: {
            const { divisionId, memberId, wildcardStateId } = action.payload;
            return {
                ...state,
                acceptance: {
                    ...state.acceptance,
                    [divisionId]: {
                        ...state.acceptance[divisionId],
                        buckets: state.acceptance[divisionId].buckets.map(bucket => {
                            bucket.players = bucket.players.map(player => {
                                // eslint-disable-next-line eqeqeq
                                if (player.memberId == memberId) {
                                    player.acceptanceWildcardStateId = wildcardStateId;
                                }
                                return player;
                            });
                            return bucket;
                        }),
                    },
                },
            };
        }
        case EVENT_PROFILE_GET_EVENT_REGIONS: {
            return {
                ...state,
                regions: {
                    ...state.regions,
                    data: [],
                    error: null,
                    loaded: false,
                    loading: true,
                },
            };
        }
        case EVENT_PROFILE_GET_EVENT_REGIONS_SUCCESS: {
            return {
                ...state,
                regions: {
                    ...state.regions,
                    data: action.payload,
                    error: null,
                    loaded: true,
                    loading: false,
                },
            };
        }
        case EVENT_PROFILE_MOVE_PLAYER_TO_ROUND_SUCCESS: {
            const { divisionId, memberId, roundType, isSpecialExempt } = action.payload;
            const { buckets } = state.acceptance[divisionId];
            const bucketIndexToUpdate = buckets.findIndex(t => t.type === acceptanceBucketTypeSortKey[roundType]);

            if (bucketIndexToUpdate >= 0) {
                const playersInBucket = buckets[bucketIndexToUpdate].players?.length;
                buckets.forEach(b => {
                    const player = b.players.find(p => p.memberId === memberId);
                    if (player) {
                        player.position = playersInBucket + 1;
                        if (roundType === acceptanceBucketTypes.MAIN && isSpecialExempt) {
                            player.acceptanceType = acceptanceRankingValues.WTA;
                            player.acceptanceListWildcardStateId = 4; // special exempt
                        }

                        b.players = b.players.filter(p => p.memberId !== memberId);
                        buckets[bucketIndexToUpdate].players.push(player);
                    }
                });
            }

            return {
                ...state,
                acceptance: {
                    ...state.acceptance,
                    [divisionId]: {
                        ...state.acceptance[divisionId],
                        buckets,
                    },
                },
            };
        }
        case EVENT_PROFILE_CROP_BANNER_PHOTO_SUCCESS: {
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        photoUrl: action.res.data.bannerUrl,
                    },
                },
            };
        }
        case EVENT_PROFILE_REG_ADD_TEAMMATE: {
            const { divisionId, player2, isInvited } = action.payload;
            const eventDivisions = [...state.event.data.eventDivisions].map((div) => {
                if (div.id === divisionId) {
                    return {
                        ...div,
                        player2,
                        isInvited,
                    };
                }
                return div;
            });
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        eventDivisions,
                    },
                },
            };
        }
        case EVENT_PROFILE_ADD_CHANGE_PARTNER_UPDATE: {
            const { divisionId, player2 } = action.payload;
            if (!(divisionId && player2)) {
                // reset state on sidebar close
                return {
                    ...state,
                    changePartnerUpdates: {},
                };
            }
            let updateObject = {};
            if (player2.needsPartner) {
                // add user to Need Partner list (register without a partner)
                updateObject = {
                    requestBody: {
                        divisionId,
                        needsPartner: true,
                    },
                    player2,
                };
            } else if (player2.divisionId) {
                // player2 picked from Need Partner list
                updateObject = {
                    requestBody: {
                        divisionId,
                        movePartnerFromDivision: {
                            fromDivisionId: player2.divisionId,
                            memberId: player2.id,
                        },
                    },
                    player2,
                };
            } else {
                // player2 picked from 'Add a partner' player search
                updateObject = {
                    requestBody: {
                        divisionId,
                        partnerIds: [player2.id],
                    },
                    player2,
                };
            }
            return {
                ...state,
                changePartnerUpdates: {
                    ...state.changePartnerUpdates,
                    [divisionId]: updateObject,
                },
            };
        }
        case EVENT_PROFILE_REG_CLEAR_TEAMMATES: {
            const { clearInvitedByPartnersOnly = false } = action.payload;
            const eventDivisions = [...state.event.data.eventDivisions].map((div) => {
                if (div.player2) {
                    const shouldClearPartner = clearInvitedByPartnersOnly
                        ? div.isInvited
                        : true;
                    if (shouldClearPartner) {
                        return {
                            ...div,
                            player2: null,
                            isInvited: false,
                        };
                    }
                }

                return div;
            });

            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        eventDivisions,
                        currentMember: {
                            ...state.event.data.currentMember,
                            isPlaying: false,
                        },
                    },
                },
            };
        }
        case EVENT_PROFILE_REG_CLEAR_PRE_REG_INVITE: {
            const { preRegistrationInviteId } = action.payload;
            const updatedPreRegInvites = state.event.data?.currentMember?.memberPreRegistrationInvites?.filter(invite => invite.preRegistrationInviteId !== preRegistrationInviteId) || [];
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        currentMember: {
                            ...state.event.data.currentMember,
                            memberPreRegistrationInvites: updatedPreRegInvites,
                        },
                    },
                },
            };
        }
        case EVENT_PROFILE_GET_MATCH_SUCCESS: {
            const { id, roundId } = action.payload;
            let nextState = state;

            if (state.currentDraw?.data?.rounds?.length) {
                const updatedRounds = state.currentDraw.data.rounds.map(round => (
                    round.id !== roundId ? round : {
                        ...round,
                        matches: round.matches.map(m => (readMatchSlice(m)?.id === id ? patchSliceMatch(m, action.payload) : m)),
                    }
                ));
                nextState = {
                    ...nextState,
                    currentDraw: { ...nextState.currentDraw, data: { ...nextState.currentDraw.data, rounds: updatedRounds } },
                };
            }

            if (state.matchSheet?.matches?.length) {
                nextState = {
                    ...nextState,
                    matchSheet: {
                        ...nextState.matchSheet,
                        matches: nextState.matchSheet.matches.map(m => (readMatchSlice(m)?.id === id ? patchSliceMatch(m, action.payload) : m)),
                    },
                };
            }

            if (state.orderOfPlaySchedule?.data?.matches?.length) {
                nextState = {
                    ...nextState,
                    orderOfPlaySchedule: {
                        ...nextState.orderOfPlaySchedule,
                        data: {
                            ...nextState.orderOfPlaySchedule.data,
                            matches: nextState.orderOfPlaySchedule.data.matches.map(m => (readMatchSlice(m)?.id === id ? patchSliceMatch(m, action.payload) : m)),
                        },
                    },
                };
            }

            return nextState;
        }
        case EVENT_PROFILE_LIVE_SCORE_UPDATE: {
            const { matchId, patch, isMatchEnded } = action.payload;
            const eventId = state.event?.data?.id;
            if (eventId != null && action.payload.eventId != null && Number(action.payload.eventId) !== Number(eventId)) {
                return state;
            }

            let nextState = { ...state };

            if (state.currentDraw?.data?.rounds?.length) {
                nextState = {
                    ...nextState,
                    currentDraw: {
                        ...state.currentDraw,
                        data: {
                            ...state.currentDraw.data,
                            rounds: updateDrawRoundMatches(state.currentDraw.data.rounds, matchId, patch),
                        },
                    },
                };
            }

            if (state.orderOfPlaySchedule?.data?.matches?.length) {
                nextState = {
                    ...nextState,
                    orderOfPlaySchedule: {
                        ...state.orderOfPlaySchedule,
                        data: {
                            ...state.orderOfPlaySchedule.data,
                            matches: updateOrderOfPlayMatches(state.orderOfPlaySchedule.data.matches, matchId, patch),
                        },
                    },
                };
            }

            const { liveMatchIdsInProgress: ids, isLive } = updateLiveBanner(
                state.liveMatchIdsInProgress,
                matchId,
                isMatchEnded,
            );
            nextState = {
                ...nextState,
                liveMatchIdsInProgress: ids,
                event: {
                    ...nextState.event,
                    data: {
                        ...nextState.event?.data,
                        isLive,
                    },
                },
            };

            return nextState;
        }
        case EVENT_PROFILE_PUBLISH_SUCCESS: {
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        published: true,
                    },
                },
            };
        }
        case EVENT_PROFILE_UNPUBLISH_SUCCESS: {
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        published: false,
                    },
                },
            };
        }
        case EVENT_PROFILE_DELETE_FAILURE: {
            return {
                ...state,
                deleteEventFailed: true,
            };
        }
        case EVENT_PROFILE_HIDE_DELETE_FAILED_POPUP: {
            return {
                ...state,
                deleteEventFailed: false,
            };
        }
        case EVENT_PROFILE_REMOVE_BANNER_PHOTO_SUCCESS: {
            return {
                ...state,
                event: {
                    ...state.event,
                    data: {
                        ...state.event.data,
                        photoUrl: null,
                    },
                },
            };
        }
        case EVENT_PROFILE_SET_REG_CONFIRMATION: {
            return {
                ...state,
                regConfirmation: action.payload,
            };
        }
        case EVENT_PROFILE_GET_INVITES_SUCCESS: {
            return {
                ...state,
                invites: action.payload,
            };
        }
        case EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS_SUCCESS: {
            return {
                ...state,
                weatherNotifications: action.payload,
            };
        }
        case EVENT_PROFILE_SET_REG_DIVISION_ID: {
            return {
                ...state,
                regDivisionId: action.payload,
            };
        }
        case EVENT_PROFILE_SET_DIVISIONS_BASED_DATE: {
            const { selectedDivisions, ...rest } = action.payload;
            return {
                ...state,
                selectedDivisionIdsByDate: {
                    ...state?.selectedDivisionIdsByDate,
                    ...rest,
                    selectedDivisions: [...(selectedDivisions || [])],
                },
            };
        }
        case EVENT_PROFILE_RESET_DIVISIONS_BASED_DATE: {
            return {
                ...state,
                selectedDivisionIdsByDate: {},
            };
        }
        case EVENT_PROFILE_SET_DECLINE_INVITATION_DATA: {
            return {
                ...state,
                declineInvitationData: action.payload,
            };
        }
        case EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE: {
            return {
                ...state,
                nextAvailableSchedule: {
                    loading: true,
                    error: null,
                    schedule: null,
                    eventId: action.payload.eventId,
                },
            };
        }
        case EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_SUCCESS: {
            return {
                ...state,
                nextAvailableSchedule: {
                    loading: false,
                    error: null,
                    schedule: action.payload.data,
                    eventId: action.payload.eventId,
                },
            };
        }
        case EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_FAILURE: {
            return {
                ...state,
                nextAvailableSchedule: {
                    loading: false,
                    error: action.payload.error,
                    schedule: null,
                    eventId: action.payload.eventId,
                },
            };
        }
        case EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES: {
            return {
                ...state,
                liveMatches: {
                    ...state.liveMatches,
                    loading: true,
                    showLoader: action.payload.showLoader,
                    matches: action.payload.matches,
                },
            };
        }
        case EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_SUCCESS: {
            return {
                ...state,
                liveMatches: {
                    loading: false,
                    loadedAtLeastOnce: true,
                    showLoader: false,
                    matches: action.payload.matches,
                    facilitiesAvailable: action.payload.facilitiesAvailable,
                },
            };
        }
        case EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_FAILURE: {
            return {
                ...state,
                liveMatches: {
                    ...state.liveMatches,
                    loading: false,
                    showLoader: false,
                    matches: [],
                    facilitiesAvailable: [],
                },
            };
        }
        case EVENT_PROFILE_GET_MEDALPRINT_DATA: {
            return {
                ...state,
                medalPrintData: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_MEDALPRINT_DATA_SUCCESS: {
            return {
                ...state,
                medalPrintData: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_MEDALPRINT_DATA_FAILURE: {
            return {
                ...state,
                medalPrintData: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS: {
            return {
                ...state,
                needsPartnerPlayers: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_SUCCESS: {
            return {
                ...state,
                needsPartnerPlayers: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_FAILURE: {
            return {
                ...state,
                needsPartnerPlayers: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_SEND_EVENT_INVITE: {
            return {
                ...state,
                eventInviteEmail: {
                    loading: true,
                    error: null,
                    success: null,
                },
            };
        }
        case EVENT_PROFILE_SEND_EVENT_INVITE_SUCCESS: {
            return {
                ...state,
                eventInviteEmail: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };
        }
        case EVENT_PROFILE_SEND_EVENT_INVITE_FAILURE: {
            return {
                ...state,
                eventInviteEmail: {
                    loading: false,
                    error: true,
                    success: null,
                },
            };
        }
        case EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS: {
            return {
                ...state,
                playerMessageEmail: {
                    loading: true,
                    error: null,
                    errorMessage: null,
                    success: null,
                },
            };
        }
        case EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_SUCCESS: {
            return {
                ...state,
                playerMessageEmail: {
                    loading: false,
                    error: null,
                    errorMessage: null,
                    success: true,
                },
            };
        }
        case EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_FAILURE: {
            return {
                ...state,
                playerMessageEmail: {
                    loading: false,
                    error: true,
                    errorMessage: action.payload?.errorMessage,
                    success: null,
                },
            };
        }
        case EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_RESET: {
            return {
                ...state,
                playerMessageEmail: {
                    loading: false,
                    error: null,
                    errorMessage: null,
                    success: null,
                },
            };
        }
        case EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS: {
            return {
                ...state,
                registeredDoublesDivisions: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_SUCCESS: {
            const { registeredDoublesDivisions } = action.payload;
            return {
                ...state,
                registeredDoublesDivisions: {
                    loading: false,
                    error: null,
                    data: registeredDoublesDivisions,
                },
            };
        }
        case EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_FAILURE: {
            return {
                ...state,
                registeredDoublesDivisions: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_RESET_REGISTERED_DOUBLES_DIVISIONS: {
            return {
                ...state,
                registeredDoublesDivisions: {
                    loading: false,
                    error: false,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS: {
            return {
                ...state,
                upcomingRecurringEvents: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_SUCCESS: {
            return {
                ...state,
                upcomingRecurringEvents: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_FAILURE: {
            return {
                ...state,
                upcomingRecurringEvents: {
                    loading: false,
                    error: true,
                    data: null,
                },
            };
        }
        case EVENT_PROFILE_GET_DIVISION_COUNTS: {
            return {
                ...state,
                divisionCounts: {
                    loading: true,
                    error: null,
                    data: state.divisionCounts.data,
                },
            };
        }
        case EVENT_PROFILE_GET_DIVISION_COUNTS_SUCCESS: {
            return {
                ...state,
                divisionCounts: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };
        }
        case EVENT_PROFILE_GET_DIVISION_COUNTS_FAILURE: {
            return {
                ...state,
                divisionCounts: {
                    loading: false,
                    error: true,
                    data: state.divisionCounts.data,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export const selectDivisionCounts = (state) => state.eventProfile.divisionCounts;
